<template>
    <fup-content-block :container="true" :full-size="false">
        <div class="mt-4 mb-4 text-center">
            <p class="lead"><i class="fas fa-exclamation-triangle"></i></p>
            <div class="small text-danger">Произошла ошибка, повторите позже.</div>
        </div>
    </fup-content-block>
</template>

<script>
    export default {
        name: "LoadingComponent"
    }
</script>